import { useSelector } from "react-redux";

import { INdaLabels } from "../../../../../features/common-attributes/types/nda-section/inda-labels.interface";

import * as campaignBriefStore from "../../../store/campaign-brief.store";

export const useNdaDependentUsers = (isUnderNda: boolean) => {
  const briefOwnerId = useSelector(campaignBriefStore.getOwnerId);
  const dependentDetails = useSelector(campaignBriefStore.getDependentUserDetails);
  const dependentUsers = [] as INdaLabels[];

  if (isUnderNda) {
    if (dependentDetails.campaignBriefOwner)
      dependentUsers.push({ id: dependentDetails.campaignBriefOwner, label: "Owner" });

    dependentDetails?.executionBriefOwners?.forEach((reviewer) => {
      if (reviewer !== briefOwnerId) dependentUsers.push({ id: reviewer, label: "EB Owner" });
    });
    dependentDetails?.workOrderOwners?.forEach((reviewer) => {
      if (reviewer !== briefOwnerId) dependentUsers.push({ id: reviewer, label: "WO Owner" });
    });

    dependentDetails?.campaignBriefReviewers?.forEach((reviewer) =>
      dependentUsers.push({ id: reviewer, label: "CB Approver" })
    );
    dependentDetails?.executionBriefReviewers?.forEach((reviewer) =>
      dependentUsers.push({ id: reviewer, label: "EB Approver" })
    );
    dependentDetails?.workOrderReviewers?.forEach((reviewer) =>
      dependentUsers.push({ id: reviewer, label: "WO Approver" })
    );
    dependentDetails?.workOrderContentCreators?.forEach((reviewer) =>
      dependentUsers.push({ id: reviewer, label: "WO Content Creator" })
    );
  }

  return dependentUsers;
};
